import { useMemo } from "react"
import { CompletionBar, DrillDownTable } from "../../widgets"
import { getTaskColumns, mapTaskToRow } from "./helpers"
import { DictStatus } from "@pma/types"

export function ProjectDrillDownContent({
  tasks,
  projectId,
  statuses,
  translate,
}: {
  tasks: any[]
  projectId: number
  statuses: DictStatus[]
  translate: (key: string) => string
}) {
  const { sections, total, done } = useMemo(() => {
    const projectTasks = tasks.filter((t) => {
      const pid = t?.project_id || t?._project?.id
      return pid === projectId
    })
    const categorized: Record<string, any[]> = { open: [], completed: [], canceled: [] }
    let doneCount = 0
    projectTasks.forEach((t) => {
      const row = mapTaskToRow(t, statuses)
      categorized[row.statusCategory]?.push(row) ?? categorized.open.push(row)
      if (row.statusCategory === "completed") doneCount++
    })
    return { sections: categorized, total: projectTasks.length, done: doneCount }
  }, [tasks, projectId, statuses])

  const columns = useMemo(() => getTaskColumns(translate, statuses), [translate, statuses])

  const completion = total > 0 ? Math.round((done / total) * 100) : 0

  const sectionLabels: Record<string, string> = {
    open: translate("Open Tasks"),
    completed: translate("Completed Tasks"),
    canceled: translate("Canceled Tasks"),
  }

  return (
    <div className='flex flex-col gap-6'>
      <CompletionBar percent={completion} />
      {(["open", "completed", "canceled"] as const).map((cat) =>
        sections[cat]?.length ? (
          <div key={cat}>
            <h4 className='mb-2 text-sm font-semibold text-foreground'>
              {sectionLabels[cat]}
              <span className='ml-2 text-xs font-normal text-muted-foreground'>
                ({sections[cat].length})
              </span>
            </h4>
            <DrillDownTable columns={columns} data={sections[cat]} />
          </div>
        ) : null,
      )}
    </div>
  )
}
